import DataGrid2 from '../..';
import { IDataGridRowCollection } from '../../entities';
import { onRowInserted } from './onRowInserted';
import { onRowInserting } from './onRowInserting';
import { onRowRemoved } from './onRowRemoved';
import { onRowRemoving } from './onRowRemoving';

export async function setSelectionResult(this: DataGrid2, rows: IDataGridRowCollection) {
	const keyExpr = this.getUniqueDataField();

	const added = rows.filter(row => !this.rows.some(r => r.data[keyExpr] === row.data[keyExpr]));

	const removed = this.rows.filter(row => !rows.some(r => r.data[keyExpr] === row.data[keyExpr]));

	const newRows: IDataGridRowCollection = this.rows.filter(row =>
		rows.some(r => r.data[keyExpr] === row.data[keyExpr])
	);

	for (const row of added) {
		const args = { cancel: null, data: row.data };
		onRowInserting.call(this, args);

		if (await args.cancel) {
			continue;
		}

		newRows.push(row);
		await onRowInserted.call(this, { data: row.data });
	}

	for (const row of removed) {
		const args = { cancel: null, data: row.data };
		onRowRemoving.call(this, args);

		if (await args.cancel) {
			newRows.push(row);
			continue;
		}

		await onRowRemoved.call(this, { data: row.data });
	}

	await this.set('rows', newRows);
}
